export const GET_ALL_ORG: string = "GET_ALL_ORG";
export const GET_ONE_ORG: string = "GET_ONE_ORG";
export const LOADING: string = "LOADING";
